import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "more-box__qty"
};
const _hoisted_2 = {
    key: 0,
    class: "filt-box__top"
};
const _hoisted_3 = { class: "form-group" };
const _hoisted_4 = { class: "form-field form-field--text form-field--3 form-field--s form-field--primary" };
const _hoisted_5 = { class: "form-field__side form-field__side--left" };
const _hoisted_6 = ["placeholder"];
const _hoisted_7 = { class: "filt-box__main" };
const _hoisted_8 = { class: "filt-box__list list" };
const _hoisted_9 = { class: "switch checkbox checkbox--s" };
const _hoisted_10 = { class: "switch__main" };
const _hoisted_11 = ["checked", "disabled", "onChange"];
const _hoisted_12 = { class: "switch__cover checkbox__cover" };
const _hoisted_13 = {
    class: "svg",
    width: "16",
    height: "16"
};
const _hoisted_14 = ["href"];
const _hoisted_15 = { class: "switch__label checkbox__label" };
const _hoisted_16 = {
    key: 0,
    class: "filt-box__extra"
};
import { computed, ref, toRaw } from "vue";
import { escapeRegex } from "../../../utils";
import Icon from "../../../components/Icon.vue";
import ItemWrapper from "./ItemWrapper.vue";
import { FilterItemTypes } from "../types";
import { hash } from "../../../components/hashes";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OptionsList',
    props: {
        item: { type: Object, required: true },
    },
    emits: ["update"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const filter = ref('');
        const showFilter = ref(false);
        const showHidden = ref(false);
        const emit = __emit;
        const count = computed(() => props.item.options.reduce((sum, option) => sum + (option.selected ? 1 : 0), 0));
        if (props.item.type === FilterItemTypes.FilterableList) {
            showFilter.value = true;
        }
        else {
            showHidden.value = true;
        }
        if (props.item.options.length < 50) {
            showFilter.value = false;
            showHidden.value = true;
        }
        const visibleOptions = computed(() => {
            var _a;
            if (showHidden.value && filter.value === '' || !showFilter.value) {
                return props.item.options;
            }
            const filteredText = ((_a = filter.value) === null || _a === void 0 ? void 0 : _a.trim()) || '';
            if (filteredText) {
                const pieces = escapeRegex(filteredText).split(new RegExp("[ .&-'`()]+", 'ui'));
                const regexp = new RegExp("(^|\\W)" + pieces.join('.*\\W'), 'ui');
                return props.item.options.filter(option => option.name.match(regexp));
            }
            return props.item.options.filter(option => showHidden.value || option.top || option.selected);
        });
        const sortedOptions = computed(() => {
            if (!props.item.active || props.item.options.length <= 5) {
                return visibleOptions.value;
            }
            return toRaw(visibleOptions.value).sort((a, b) => {
                if ((a.pinned !== undefined ? a.pinned : a.selected) !== (b.pinned !== undefined ? b.pinned : b.selected)) {
                    return a.selected ? -1 : 1;
                }
                return 0;
            });
        });
        function expand() {
            showHidden.value = true;
        }
        function onchange(option, selected) {
            option.pinned = !selected;
            option.selected = selected;
            let active = false;
            for (const option of props.item.options) {
                if (option.selected) {
                    active = true;
                    break;
                }
            }
            props.item.active = active;
            emit('update', true);
        }
        function reset() {
            if (!props.item.active) {
                return;
            }
            for (const option of props.item.options) {
                if (option.selected) {
                    option.selected = false;
                }
            }
            props.item.active = false;
            emit('update', false);
        }
        return (_ctx, _cache) => {
            return (__props.item.options.length)
                ? (_openBlock(), _createBlock(ItemWrapper, {
                    key: 0,
                    item: __props.item,
                    onReset: reset
                }, {
                    badge: _withCtx(() => [
                        (__props.item.active)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(count.value), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true)
                    ]),
                    body: _withCtx(() => [
                        (showFilter.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _createElementVNode("div", _hoisted_3, [
                                    _createElementVNode("div", _hoisted_4, [
                                        _createElementVNode("div", _hoisted_5, [
                                            _createVNode(Icon, {
                                                name: "search",
                                                "class-name": "form-icon"
                                            })
                                        ]),
                                        _cache[1] || (_cache[1] = _createTextVNode()),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control",
                                            placeholder: __props.item.placeholder,
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((filter).value = $event))
                                        }, null, 8 /* PROPS */, _hoisted_6), [
                                            [_vModelText, filter.value]
                                        ])
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("v-if", true),
                        _cache[6] || (_cache[6] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("ul", _hoisted_8, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedOptions.value, (option) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                        class: "filt-box__item list__item",
                                        key: option.value
                                    }, [
                                        _createElementVNode("div", _hoisted_9, [
                                            _createElementVNode("label", _hoisted_10, [
                                                _createElementVNode("input", {
                                                    type: "checkbox",
                                                    class: "switch__input",
                                                    checked: option.selected,
                                                    disabled: !option.available,
                                                    onChange: ($event) => (onchange(option, $event.target.checked))
                                                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_11),
                                                _cache[2] || (_cache[2] = _createTextVNode()),
                                                _createElementVNode("span", _hoisted_12, [
                                                    (_openBlock(), _createElementBlock("svg", _hoisted_13, [
                                                        _createElementVNode("use", {
                                                            href: `/img/sprite.svg?v=${_unref(hash)('sprite')}#check-16`
                                                        }, null, 8 /* PROPS */, _hoisted_14)
                                                    ]))
                                                ]),
                                                _cache[3] || (_cache[3] = _createTextVNode()),
                                                _createElementVNode("span", _hoisted_15, _toDisplayString(option.name), 1 /* TEXT */)
                                            ])
                                        ])
                                    ]));
                                }), 128 /* KEYED_FRAGMENT */))
                            ]),
                            _cache[5] || (_cache[5] = _createTextVNode()),
                            (showFilter.value && !showHidden.value && !filter.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                    _createElementVNode("div", { class: "filt-box__more-link" }, [
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: "btn btn--4 btn--s btn--black",
                                            onClick: expand
                                        }, [...(_cache[4] || (_cache[4] = [
                                                _createElementVNode("span", { class: "btn__label" }, "Показать все", -1 /* CACHED */)
                                            ]))])
                                    ])
                                ]))
                                : _createCommentVNode("v-if", true)
                        ])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["item"]))
                : _createCommentVNode("v-if", true);
        };
    }
});
